import moment, { MomentInput } from 'moment';

const defaultFormat = 'YYYY-MM-DD HH:mm:ss';

export default function parseDateTime(date: MomentInput, format: string = defaultFormat) {
  return moment(date).format(format);
}
